var _possibleConstructorReturn = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _assertThisInitialized = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var EventEmitter = require('events');

var lmerge = require('lodash.merge');

var uniqid = require('uuid/v4');

var debug = require('debug');

var debugManager = debug('spa');

var DEFAULT_OPTIONS = function DEFAULT_OPTIONS() {
  return {
    id: uniqid(),
    initiator: false,
    channelConfig: {},
    channelName: uniqid(),
    config: {
      iceServers: [{
        urls: 'stun:stun.l.google.com:19302'
      }]
    },
    constraints: {},
    offerConstraints: {},
    answerConstraints: {},
    reconnectTimer: false,
    sdpTransform: function sdpTransform(sdp) {
      return sdp;
    },
    stream: false,
    streams: [],
    trickle: true,
    wrtc: {},
    // RTCPeerConnection/RTCSessionDescription/RTCIceCandidate
    objectMode: false
  };
};

var Manager =
/*#__PURE__*/
function () {
  "use strict";

  function Manager() {
    _classCallCheck(this, Manager);

    this._statistics = {
      message: 0
    };
    this.manager = new Map();
    this._options = {
      latency: function latency(send) {
        setTimeout(send, 0);
      }
    };
    debugManager('manager initialized');
  }

  _createClass(Manager, [{
    key: "newPeer",
    value: function newPeer(peer) {
      debugManager('new peer added. Size:', this.manager.size);
      this.manager.set(peer.id, peer);
    }
  }, {
    key: "connect",
    value: function connect(from, to) {
      debugManager('peer connected from/to: ', from, to);

      this.manager.get(to)._connectWith(from);

      this.manager.get(from)._connectWith(to);
    }
  }, {
    key: "destroy",
    value: function destroy(from, to) {
      debugManager('peer disconnected from/to: ', from, to);

      if (this.manager.get(from)) {
        this.manager.get(from)._close();

        this.manager.delete(from);
      }

      if (this.manager.get(to)) {
        this.manager.get(to)._close();

        this.manager.delete(to);
      }
    }
  }, {
    key: "send",
    value: function send(from, to, msg) {
      var retry = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      // this._options.latency(() => {
      this._send(from, to, msg, retry); // })

    }
  }, {
    key: "_send",
    value: function _send(from, to, msg) {
      var retry = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      try {
        if (!this.manager.has(from) || !this.manager.has(to)) throw new Error('need a from and to peer.');
        this.manager.get(to).emit('data', msg);
        this._statistics.message++;
      } catch (e) {
        throw new Error('cannot send the message. perhaps your destination is not reachable.', e);
      }
    }
  }, {
    key: "stats",
    get: function get() {
      return this._statistics;
    }
  }]);

  return Manager;
}();

var manager = new Manager();

module.exports =
/*#__PURE__*/
function (_EventEmitter) {
  "use strict";

  _inherits(SimplePeerAbstract, _EventEmitter);

  function SimplePeerAbstract(options) {
    var _this;

    _classCallCheck(this, SimplePeerAbstract);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimplePeerAbstract).call(this));
    _this._manager = manager;
    _this._options = lmerge(DEFAULT_OPTIONS(), options);
    _this.id = _this._options.id;
    _this.WEBRTC_SUPPORT = true; // yes but this a fake

    _this._isNegotiating = false;
    _this.connected = false;
    _this.disconnected = false;
    _this.connectedWith = undefined;
    _this.messageBuffer = [];
    debugManager('peer initiated:', _this.id, _this._options.initiator);

    if (_this._options.initiator) {
      // workaround to wait for a listener on 'signal'
      process.nextTick(function () {
        _this._init();
      });
    }

    _this._manager.newPeer(_assertThisInitialized(_assertThisInitialized(_this)));

    return _this;
  }

  _createClass(SimplePeerAbstract, [{
    key: "send",
    value: function send(data) {
      if (!this.connectedWith) {
        this.messageBuffer.push(data);
      } else {
        if (this.messageBuffer.length > 0) {
          this._reviewMessageBuffer();
        }

        if (this.connectedWith) {
          this._send(this.connectedWith, data);
        } else {
          this.messageBuffer.push(data);
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._manager.destroy(this.id, this.connectedWith);
    }
  }, {
    key: "signal",
    value: function signal(data) {
      if (data.type === 'init') {
        this._isNegotiating = true;
        debugManager('offer-init received:', data);
        this.emit('signal', this._createAccept(data));
      } else if (data.type === 'accept') {
        debugManager('offer-accept received:', data);

        this._connect(data);
      }
    }
  }, {
    key: "_error",
    value: function _error(error) {
      debugManager(error);
      this.emit('error', error);
    }
  }, {
    key: "_close",
    value: function _close() {
      debugManager('[%s] is closed.', this.id);
      this.emit('close');
    }
  }, {
    key: "_init",
    value: function _init() {
      this._isNegotiating = true;

      var offer = this._createOffer();

      this.emit('signal', offer);
    }
  }, {
    key: "_createOffer",
    value: function _createOffer() {
      var newOffer = {
        offerId: uniqid(),
        type: 'init',
        offer: {
          initiator: this.id
        }
      };
      return newOffer;
    }
  }, {
    key: "_createAccept",
    value: function _createAccept(offer) {
      var acceptedOffer = this._createOffer();

      acceptedOffer.type = 'accept';
      acceptedOffer.offerId = offer.offerId;
      acceptedOffer.offer.initiator = offer.offer.initiator;
      acceptedOffer.offer.acceptor = this.id;
      return acceptedOffer;
    }
  }, {
    key: "_reviewMessageBuffer",
    value: function _reviewMessageBuffer() {
      debugManager('Review the buffer: ', this.messageBuffer.length);

      while (this.connectedWith && this.messageBuffer.length !== 0) {
        this._send(this.messageBuffer.pop());
      }
    }
  }, {
    key: "_send",
    value: function _send() {
      var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.connectedWith;
      var data = arguments.length > 1 ? arguments[1] : undefined;
      if (!to) throw new Error('It must have a destination.');

      this._manager.send(this.id, to, data);
    }
  }, {
    key: "_connect",
    value: function _connect(offer) {
      if (!offer.offer.acceptor) throw new Error('It must have an acceptor');

      this._manager.connect(offer.offer.initiator, offer.offer.acceptor);
    }
  }, {
    key: "_connectWith",
    value: function _connectWith(connectedWith) {
      this.connected = true;
      this._isNegotiating = false;
      this.connectedWith = connectedWith;
      this.emit('connect');
    }
  }], [{
    key: "manager",
    get: function get() {
      return manager;
    }
  }]);

  return SimplePeerAbstract;
}(EventEmitter);